import { z } from 'zod';
import { MULTI_SELECT_ENTITIY_LIMIT } from '@soundxyz/utils/const';
import { ManuallyAddedAllowlistSchema } from '../../fields';
import { EditErrorMessages } from '../errors';
import { EditCollectorsOfArtistsSchema, EditCollectorsOfReleasesSchema } from './releaseInfo';

const Allowlists = z.object({
  userChange: z.boolean(),
  collectorsOfReleases: EditCollectorsOfReleasesSchema.nullish().transform(value => {
    return {
      allArtistReleases: value?.allArtistCollaborations ?? false,
      allArtistCollaborations: value?.allArtistCollaborations ?? false,
      selectedReleaseIds: value?.selectedReleaseIds ?? [],
      releasesInfo: value?.releasesInfo ?? [],
    };
  }),
  collectorsOfArtists: EditCollectorsOfArtistsSchema.nullish().transform(value => {
    return {
      allArtistCollectors: value?.allArtistCollectors ?? true,
      allCollaboratingArtists: value?.allCollaboratingArtists ?? false,
      selectedArtistIds: value?.selectedArtistIds ?? [],
      artistsInfo: value?.artistsInfo ?? [],
    };
  }),
  manuallyAddedAllowlist: ManuallyAddedAllowlistSchema,
});

export const AllowlistsSchema = z
  .record(
    z
      .string()
      .nonempty()
      .refine(value => {
        return value;
      }),
    z.array(Allowlists),
  )
  .superRefine((value, ctx) => {
    const allowlistValuesForReleaseId = Object.values(value)[0];

    if (!allowlistValuesForReleaseId) return;

    const allowlistValues = allowlistValuesForReleaseId[0];

    if (!allowlistValues) return value;

    const hasManuallyAddedAddresses =
      allowlistValues?.manuallyAddedAllowlist?.addresses &&
      allowlistValues?.manuallyAddedAllowlist?.addresses.length > 0;
    const hasCollectorsOfReleases =
      (allowlistValues?.collectorsOfReleases?.selectedReleaseIds
        ? allowlistValues?.collectorsOfReleases?.selectedReleaseIds.length > 0
        : false) || allowlistValues?.collectorsOfReleases?.allArtistCollaborations;
    const hasCollectorsOfArtists =
      (allowlistValues?.collectorsOfArtists?.selectedArtistIds
        ? allowlistValues?.collectorsOfArtists?.selectedArtistIds.length > 0
        : false) || allowlistValues?.collectorsOfArtists?.allArtistCollectors;

    if (!hasManuallyAddedAddresses && !hasCollectorsOfReleases && !hasCollectorsOfArtists) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: EditErrorMessages.addresses.required_error,
        path: ['addresses'],
      });
      return;
    }

    if (
      allowlistValues.collectorsOfReleases?.selectedReleaseIds &&
      allowlistValues.collectorsOfReleases.selectedReleaseIds.length > MULTI_SELECT_ENTITIY_LIMIT
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: EditErrorMessages.collectorsOfReleases.list_too_long,
        path: ['collectorsOfReleases'],
      });
    }

    if (
      allowlistValues.collectorsOfArtists?.selectedArtistIds &&
      allowlistValues.collectorsOfArtists.selectedArtistIds.length > MULTI_SELECT_ENTITIY_LIMIT
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: EditErrorMessages.collectorsOfArtists.list_too_long,
        path: ['collectorsOfArtists'],
      });
    }

    return value;
  });
